import React from 'react';
import './Badge.css';

const Badge = ({ text, type = 'primary' }) => {
  return (
    <span className={`badge bg-${type}`}>
      {text}
    </span>
  );
};

export default Badge;